import { createSlice } from "@reduxjs/toolkit";

/**
 * 파일명: systemInfoSlice.js
 * 작성자: 권도훈
 * 작성일자: 25.02.26
 * 설명: 사용자 정보
 */

// useable online meeting option list
const useableOnlineCodeList = [
  "CD0201",
  "CD0202",
  "CD0203",
  "CD0204",
  "CD0205",
];

const systemInfoSlice = createSlice({
  name: "systemInfoSlice",
  initialState: {
    systemType: "", // default reserve system option
    isOnline: false, // useable online meeting option6
  },
  reducers: {
    insertSystemInfo: (state, action) => {
      state.systemType = action.payload.systemType;
      state.isOnline = useableOnlineCodeList.includes(
        action.payload.systemType
      );
    },
  },
});

export default systemInfoSlice;

export const { insertSystemInfo } = systemInfoSlice.actions;
